<div class="identifier-import" fxLayout="column" fxLayoutGap="15px" [formGroup]="ockImportForm">
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane importu</h3>
          </div>

          <div fxLayout="row">
            <mat-form-field fxFlex="100">
              <ngx-mat-file-input
                #fileInput
                placeholder="Plik importu ({{fileMaxSize | byteFormat}})"
                [required]="true"
                [formControl]="fileControl"
                [multiple]="false"
                [accept]="'.csv'"
                (click)="resetFileValue()"
              ></ngx-mat-file-input>
              <mat-icon matSuffix color="accent">attachment</mat-icon>
              <mat-error *ngIf="fileControl.hasError('required')">Wybierz plik</mat-error>
              <mat-error *ngIf="fileControl.hasError('maxContentSize')">
                Całkowity rozmiar pliku nie może przekraczać
                {{fileControl.getError('maxContentSize').maxSize | byteFormat}}
                (Wybrany plik: {{fileControl.getError('maxContentSize').actualSize
                | byteFormat}}).
              </mat-error>

            </mat-form-field>
          </div>

          <mat-error *ngIf="ockImportForm.get('fileContent').hasError('backendError')">
            {{ockImportForm.get('fileContent').getError('backendError')}}
          </mat-error>



          <div fxLayout="row">
            <div fxFlex="100" class="slide-padding">
              <mat-slide-toggle color="accent" formControlName="nipImport">
                Import NIP
              </mat-slide-toggle>
            </div>
            <div fxFlex="100" class="slide-padding">
              <mat-slide-toggle color="accent" formControlName="vinImport">
                Import VIN
              </mat-slide-toggle>
            </div>
          </div>



        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="import()" [class.spinner]="processingRequest"
            [disabled]="!ockImportFormValid"
            mat-stroked-button color="primary"><mat-icon>publish</mat-icon> <span> Importuj</span></button>
    <button (click)="cancel($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>

  </div>
</div>
